<div>
  <a content [routerLink]="['/products', productId()?.toString() ?? '']">
    <ideal-render-target-cart-item-result-images image *ifHasRenderInSources="LayoutComponents[LayoutTargets.Images]" />
    <ideal-render-target-cart-item-result-title title *ifHasRenderInSources="LayoutComponents[LayoutTargets.Title]" />
    <ideal-render-target-cart-item-result-notice notice *ifHasRenderInSources="LayoutComponents[LayoutTargets.Notice]" />
    <ideal-render-target-cart-item-result-description description *ifHasRenderInSources="LayoutComponents[LayoutTargets.Description]" />
    <ideal-render-target-cart-item-result-summary summary *ifHasRenderInSources="LayoutComponents[LayoutTargets.Summary]" />
  </a>
  <ideal-render-target-cart-item-result-actions actions *ifHasRenderInSources="LayoutComponents[LayoutTargets.Actions]" />
  <ideal-render-target-cart-item-result-info info *ifHasRenderInSources="LayoutComponents[LayoutTargets.Info]" />
  <ideal-render-target-cart-item-result-extended extended *ifHasRenderInSources="LayoutComponents[LayoutTargets.Extended]" />
</div>
@if (typeComponentInjector() && itemTypeComponents()) {
  <div style="display: none">
    @for (component of itemTypeComponents(); track $index) {
      <ng-container *ngComponentOutlet="component; injector: typeComponentInjector(); inputs: componentInputs()"></ng-container>
    }
  </div>
}
